module.exports = __webpack_public_path__ + "img/bg_chess_07.658d33bf.jpg";